import { render } from "./RelatedPartsTableSkeleton.vue?vue&type=template&id=227e72ea&scoped=true&ts=true"
import script from "./RelatedPartsTableSkeleton.vue?vue&type=script&lang=ts"
export * from "./RelatedPartsTableSkeleton.vue?vue&type=script&lang=ts"

import "./RelatedPartsTableSkeleton.vue?vue&type=style&index=0&id=227e72ea&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227e72ea"]])

export default __exports__